import { Formik } from "formik";
import { YUPValidations } from "./helper";
import { useEffect, useState } from "react";
import {
  MandatoryStar,
  getSnackbarSuccess,
  isLoadingAction,
} from "../../../../Utils/helper";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { clearCurrentPage } from "../../../NetworkPortal/ProviderProfileDetails/helper";
import {
  addProviderNetworkSKUPackageAction,
  getNetworkSKUPackageDetailByIdAction,
  getSkuPackagesNetworkAction,
  activeInactiveTestPackageNetworkAction,
} from "../../../../redux/actions/TestPackageNetworkAction";
import { getProvidersTestListAction } from "../../../../redux/actions/TestPackagesAction";
import { getSkuSearchTagValues } from "../Test/helper";

export const AddQuicklyPackageSKUPopup = ({
  userDetail,
  setIsAddSku,
  searchFilter,
  apiParams,
}) => {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [showMoreFields, setShowMoreFields] = useState(false);
  const [packageId, setPackageId] = useState(userDetail?.facilityId);
  const [providerId, setProviderId] = useState(userDetail?.providerId);
  const [globalTestDetailsList, setGlobalTestDetailsList] = useState([]);

  const TestPackageReducer = useSelector((state) => state?.TestPackageReducer);
  const providerPortalDetailReducer = useSelector(
    (state) => state?.providerPortalDetailReducer
  );

  useEffect(() => {
    if (packageId && providerId) {
      const temp = packageId === null ? 0 : packageId;
      const resp = dispatch(getProvidersTestListAction(temp, providerId));
      resp.then((res) => {
        setGlobalTestDetailsList(res?.data?.results?.lstGlobalTestDetails);
      });
    }
  }, [packageId, providerId]);

  useEffect(() => {
    if (userDetail !== null) {
      const resp = dispatch(
        getNetworkSKUPackageDetailByIdAction({
          providerPackageStgId: userDetail?.providerFacilityStgId,
          providerPackageId: userDetail?.providerFacilitiesId,
          providerId: userDetail?.providerId,
        })
      );
      resp.then((res) => {
        setData({
          ...res?.data?.results,
          isActive: res?.data?.results?.isActive === "Y" ? true : false,
        });
      });
    }
  }, [userDetail]);

  const handleClose =  () => {
    setIsAddSku(false);
    setData(null);
    setTimeout(() => {
       dispatch(
        getSkuPackagesNetworkAction({ ...searchFilter, ...apiParams })
      );
    }, 1000);
  };

  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black">
          {userDetail === null ? "Add Rate Card" : "Edit Rate Card"}&nbsp;
          &nbsp;
          {userDetail !== null && (
            <button
            style={{cursor:"default" }}
              className={`btn ${
                data?.requestStatus === "Approved"
                  ? "btn-success"
                  : "btn-warning"
              }`}
            >
              {data?.requestStatus}
            </button>
          )}
        </h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={handleClose}
        ></button>
      </div>
      <Formik
        enableReinitialize={true}
        initialValues={{ ...data }}
        onSubmit={async (values) => {
          const temp = {
            ...values,
            mrp: values?.mrp || null,
            fromDate:values?.fromDate.split("T")[0] || null,
            toDate:values?.toDate.split("T")[0] || null,
            walkInPrice: values?.walkInPrice || null,
            agreedRate: values?.agreedRate || null,
            defaultMargin: parseInt(values?.defaultMargin),
            minimumAge: parseInt(values?.minimumAge),
            maxAge: parseInt(values?.maxAge),
            minRefRangeMale: parseFloat(values?.minRefRangeMale),
            maxRefRangeMale: parseFloat(values?.maxRefRangeMale),
            idealValueMale: parseFloat(values?.idealValueMale),
            minRefRangeFemale: parseFloat(values?.minRefRangeFemale),
            maxRefRangeFemale: parseFloat(values?.maxRefRangeFemale),
            idealValueFemale: parseFloat(values?.idealValueFemale),
            providerPackageStgId:
              userDetail === null ? 0 : values?.providerPackageStgId,
            providerPackageId:
              userDetail === null ? 0 : values?.providerPackageId,
            isActive: values?.isActive ? "Y" : "N",
          };
          const resp = dispatch(addProviderNetworkSKUPackageAction(temp));
          resp.then((res) => {
            isLoadingAction(true, dispatch);
            if (res?.data?.status === true) {
              clearCurrentPage(dispatch);
              getSnackbarSuccess("success", res?.data?.message, dispatch);
              isLoadingAction(false, dispatch);
              handleClose();
            } else {
              getSnackbarSuccess("error", res?.data?.message, dispatch);
              isLoadingAction(false, dispatch);
            }
          });
        }}
        validationSchema={YUPValidations}
      >
        {(props) => {
          const { values, errors, handleChange, handleSubmit, setFieldValue } =
            props;
          return (
            <form className="form-admin" onSubmit={handleSubmit}>
              <div className="modal-body addusermodalbox">
                {userDetail !== null && (
                  <div className="row">
                    <div className="col-lg-6 col-md-6">
                      <label className="col-form-label">
                        HA Package Name: &nbsp;
                      </label>
                      <label className="col-form-label">
                        {userDetail?.facilityName}
                      </label>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <label className="col-form-label">
                        Provider Name:&nbsp;
                      </label>
                      <label className="col-form-label">
                        {userDetail?.providerName}
                      </label>
                    </div>
                  </div>
                )}
                <div className="row">
                  {userDetail === null && (
                    <>
                      <div className="col-lg-6 col-md-6">
                        <label htmlFor=" Role" className="col-form-label">
                          Provider Name
                          <MandatoryStar />
                        </label>
                        <Select
                          className="basic-multi-select select_provider_test"
                          classNamePrefix="select"
                          placeholder="Search Provider Name or Code"
                          name="colors"
                          isClearable={true}
                          options={TestPackageReducer?.getProviderListNetworkDetails?.map(
                            (ele) => {
                              return {
                                value: ele?.providerId,
                                label: ele?.providerName,
                              };
                            }
                          )}
                          onChange={(e) => {
                            setProviderId(e?.value);
                            setFieldValue(
                              "providerId",
                              e === null ? 0 : e?.value
                            );
                            setFieldValue(
                              "providerName",
                              e === null ? e : e?.label
                            );
                          }}
                          value={
                            values?.providerId
                              ? {
                                  value: values?.providerId,
                                  label: values?.providerName,
                                }
                              : null
                          }
                          required
                        />
                        <div className="errorInputMessage">
                          {errors?.providerName}
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <label htmlFor=" Role" className="col-form-label">
                          HA Package Name
                          <MandatoryStar />
                        </label>
                        <Select
                          className="basic-multi-select select_provider_test"
                          classNamePrefix="select"
                          placeholder="Search HA Package Name or Code"
                          name="colors"
                          isClearable={true}
                          options={providerPortalDetailReducer?.getFacilityReason?.map(
                            (ele) => {
                              return {
                                value: ele?.facilityId,
                                label: ele?.facilityName,
                              };
                            }
                          )}
                          onChange={(e) => {
                            setFieldValue(
                              "facilityId",
                              e === null ? 0 : e?.value
                            );
                            setFieldValue(
                              "facilityName",
                              e === null ? e : e?.label
                            );
                            setPackageId(e?.value);
                          }}
                          value={
                            values?.facilityId
                              ? {
                                  value: values?.facilityId,
                                  label: values?.facilityName,
                                }
                              : null
                          }
                          required
                        />
                        <div className="errorInputMessage">
                          {errors?.facilityName}
                        </div>
                      </div>
                    </>
                  )}
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor=" Role" className="col-form-label">
                      Centre Package Code
                      {/* <MandatoryStar /> */}
                    </label>
                    <input
                      name="centrePackageCode"
                      type="text"
                      placeholder="Centre Package Code"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.centrePackageCode}
                      onChange={handleChange}
                    />
                    <div className="errorInputMessage">
                      {errors?.centrePackageCode}
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor="User Type" className="col-form-label">
                      Centre Package Name
                      {/* <MandatoryStar /> */}
                    </label>
                    <input
                      name="centrePackageName"
                      type="text"
                      placeholder="Centre Package Name"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.centrePackageName}
                      onChange={handleChange}
                    />
                    <div className="errorInputMessage">
                      {errors?.centrePackageName}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label htmlFor=" Role" className="col-form-label">
                      DC Rate
                      <MandatoryStar />
                    </label>
                    <input
                      name="agreedRate"
                      type="number"
                      onKeyDown={(e) => {
                        if (e.key === " " || e.key === "-" || e.key === "+") {
                          e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                        }
                      }}
                      step="0.01"
                      presicion={2}
                      placeholder="DC Rate"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.agreedRate}
                      onChange={handleChange}
                    />
                    <div className="errorInputMessage">
                      {errors?.agreedRate}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label htmlFor=" Role" className="col-form-label">
                      DC MRP (Rs.)
                      <MandatoryStar />
                    </label>
                    <input
                      name="mrp"
                      type="number"
                      step="0.01"
                      presicion={2}
                      onKeyDown={(e) => {
                        if (e.key === " " || e.key === "-" || e.key === "+") {
                          e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                        }
                      }}
                      placeholder="DC MRP"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.mrp}
                      onChange={handleChange}
                    />
                    <div className="errorInputMessage">{errors?.mrp}</div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label htmlFor=" Role" className="col-form-label">
                      DC Walk In Price
                      {/* <MandatoryStar /> */}
                    </label>
                    <input
                      name="walkInPrice"
                      type="number"
                      step="0.01"
                      presicion={2}
                      onKeyDown={(e) => {
                        if (e.key === " " || e.key === "-" || e.key === "+") {
                          e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                        }
                      }}
                      placeholder="DC Walk In Price"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.walkInPrice}
                      onChange={handleChange}
                    />
                    <div className="errorInputMessage">
                      {errors?.walkInPrice}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label htmlFor=" Role" className="col-form-label">
                      Gender
                      {/* <MandatoryStar /> */}
                    </label>
                    <select
                      name="gender"
                      className="form-select form-select-admin"
                      value={values?.gender}
                      onChange={handleChange}
                    >
                      <option value="">Select Gender</option>
                      <option value="M">Male</option>
                      <option value="F">Female</option>
                      <option value="B">Both</option>
                    </select>
                    <div className="errorInputMessage">{errors?.gender}</div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label htmlFor=" Role" className="col-form-label">
                      Fasting Required
                      {/* <MandatoryStar /> */}
                    </label>
                    <select
                      name="fastingRequired"
                      className="form-select form-select-admin"
                      value={values?.fastingRequired}
                      onChange={(e) => {
                        setFieldValue(
                          "fastingRequired",
                          e.target.value === "true"
                            ? true
                            : e.target.value === "false"
                            ? false
                            : e.target.value
                        );
                      }}
                    >
                      <option value="">Select</option>
                      <option value={true}>Yes</option>
                      <option value={false}>No</option>
                    </select>
                    <div className="errorInputMessage">
                      {errors?.fastingRequired}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label htmlFor=" Role" className="col-form-label">
                      Visit Type
                      <MandatoryStar />
                    </label>
                    <select
                      name="visitType"
                      className="form-select form-select-admin"
                      value={values?.visitType}
                      onChange={(e) => {
                        setFieldValue("visitType", e.target.value);
                      }}
                    >
                      <option value="">Select Visit Type</option>
                      <option value="HV">Home Visit</option>
                      <option value="DC"> Centre Visit</option>
                    </select>
                    <div className="errorInputMessage">{errors?.visitType}</div>
                  </div>
                  {userDetail !== null && <div className="col-lg-4 col-md-4">
                    <label htmlFor=" Role" className="col-form-label">
                      App Price
                    </label>
                    <input
                      name="walkInPrice"
                      placeholder="App Price"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.appPrice1Graded}
                      disabled={true}
                    />
                  </div>}
                  <div className="col-lg-4 col-md-4">
                    <label htmlFor="fromDate" className="col-form-label">
                     From Date
                      <MandatoryStar />
                    </label>
                    <input
                      name="fromDate"
                      type="date"
                      // placeholder="dd-mm-yyyy"
                      // step="0.01"
                      // presicion={2}
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.fromDate ? values?.fromDate.split("T")[0] : null}
                      onChange={handleChange}
                    />
                    <div className="errorInputMessage">{errors?.fromDate}</div>
                  </div>
                   <div className="col-lg-4 col-md-4">
                    <label htmlFor="toData" className="col-form-label">
                     To Date
                      <MandatoryStar />
                    </label>
                    <input
                      name="toDate"
                      type="date"
                      // placeholder="dd-mm-yyyy"
                      // step="0.01"
                      // presicion={2}
                      // min={new Date()}
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.toDate ? values?.toDate.split("T")[0] : null}
                      onChange={handleChange}
                    />
                    <div className="errorInputMessage">{errors?.toDate}</div>
                  </div>
                  {/* {showMoreFields && (
                    <>
                      <div className="col-lg-4 col-md-4">
                        <label htmlFor=" Role" className="col-form-label">
                          Sub Category
                        </label>
                        <input
                          name="subCategory"
                          type="text"
                          placeholder="Sub Category"
                          className="form-control form-select-admin inputbgavanish"
                          value={values?.subCategory}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label htmlFor=" Role" className="col-form-label">
                          Default Margin
                        </label>
                        <input
                          name="defaultMargin"
                          type="text"
                          placeholder="Default Margin"
                          className="form-control form-select-admin inputbgavanish"
                          value={values?.defaultMargin}
                          onChange={(e) => {
                            setFieldValue(
                              "defaultMargin",
                              e.target.value === "" ? null : e.target.value
                            );
                          }}
                        />
                        <div className="errorInputMessage">
                          {errors?.defaultMargin}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label htmlFor=" Role" className="col-form-label">
                          Display Facility Name
                        </label>
                        <input
                          name="displayFacilityName"
                          type="text"
                          placeholder="Display Facility Name"
                          className="form-control form-select-admin inputbgavanish"
                          value={values?.displayFacilityName}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label htmlFor=" Role" className="col-form-label">
                          Prepration For Checkup
                        </label>
                        <input
                          name="preprationForCheckup"
                          type="text"
                          placeholder="Prepration For Checkup"
                          className="form-control form-select-admin inputbgavanish"
                          value={values?.preprationForCheckup}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label htmlFor=" Role" className="col-form-label">
                          Package Synonyms
                        </label>
                        <input
                          name="skuSynonyms"
                          type="text"
                          placeholder="SKU Synonyms"
                          className="form-control form-select-admin inputbgavanish"
                          value={values?.skuSynonyms}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label htmlFor=" Role" className="col-form-label">
                          Package Long Description
                        </label>
                        <input
                          name="skuLongDescription"
                          type="text"
                          placeholder="SKU Long Description"
                          className="form-control form-select-admin inputbgavanish"
                          value={values?.skuLongDescription}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label htmlFor=" Role" className="col-form-label">
                          Minimum Age
                        </label>
                        <input
                          name="minimumAge"
                          type="number"
                          onKeyDown={(e) => {
                            if (
                              e.key === " " ||
                              e.key === "-" ||
                              e.key === "+"
                            ) {
                              e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                            }
                          }}
                          placeholder="Minimum Age"
                          className="form-control form-select-admin inputbgavanish"
                          value={values?.minimumAge}
                          onChange={(e) => {
                            setFieldValue(
                              "minimumAge",
                              e.target.value === "" ? null : e.target.value
                            );
                          }}
                        />
                        <div className="errorInputMessage">
                          {errors?.minimumAge}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label htmlFor=" Role" className="col-form-label">
                          Maximum Age
                        </label>
                        <input
                          name="maxAge"
                          type="number"
                          onKeyDown={(e) => {
                            if (
                              e.key === " " ||
                              e.key === "-" ||
                              e.key === "+"
                            ) {
                              e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                            }
                          }}
                          placeholder="Max Age"
                          className="form-control form-select-admin inputbgavanish"
                          value={values?.maxAge}
                          onChange={(e) => {
                            setFieldValue(
                              "maxAge",
                              e.target.value === "" ? null : e.target.value
                            );
                          }}
                        />
                        <div className="errorInputMessage">
                          {errors?.maxAge}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label htmlFor=" Role" className="col-form-label">
                          Final Reporting
                        </label>
                        <input
                          name="finalReporting"
                          type="text"
                          placeholder="Final Reporting"
                          className="form-control form-select-admin inputbgavanish"
                          value={values?.finalReporting}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label htmlFor=" Role" className="col-form-label">
                          Sample Type
                        </label>
                        <input
                          name="sampleType"
                          type="text"
                          placeholder="Sample Type"
                          className="form-control form-select-admin inputbgavanish"
                          value={values?.sampleType}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label htmlFor=" Role" className="col-form-label">
                          Min Ref Range Male
                        </label>
                        <input
                          name="minRefRangeMale"
                          type="text"
                          placeholder="Min Ref Range Male"
                          className="form-control form-select-admin inputbgavanish"
                          value={values?.minRefRangeMale}
                          onChange={handleChange}
                        />
                        <div className="errorInputMessage">
                          {errors?.minRefRangeMale}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label htmlFor=" Role" className="col-form-label">
                          Max Ref Range Male
                        </label>
                        <input
                          name="maxRefRangeMale"
                          type="text"
                          placeholder="Max Ref Range Male"
                          className="form-control form-select-admin inputbgavanish"
                          value={values?.maxRefRangeMale}
                          onChange={handleChange}
                        />
                        <div className="errorInputMessage">
                          {errors?.maxRefRangeMale}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label htmlFor=" Role" className="col-form-label">
                          Ideal Value Male
                        </label>
                        <input
                          name="idealValueMale"
                          type="text"
                          placeholder="Ideal Value Male"
                          className="form-control form-select-admin inputbgavanish"
                          value={values?.idealValueMale}
                          onChange={handleChange}
                        />
                        <div className="errorInputMessage">
                          {errors?.idealValueMale}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label htmlFor=" Role" className="col-form-label">
                          Units Male
                        </label>
                        <input
                          name="unitsMale"
                          type="text"
                          placeholder="Units Male"
                          className="form-control form-select-admin inputbgavanish"
                          value={values?.unitsMale}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label htmlFor=" Role" className="col-form-label">
                          Min Ref Range Female
                        </label>
                        <input
                          name="minRefRangeFemale"
                          type="text"
                          placeholder="Min Ref Range Female"
                          className="form-control form-select-admin inputbgavanish"
                          value={values?.minRefRangeFemale}
                          onChange={handleChange}
                        />
                        <div className="errorInputMessage">
                          {errors?.minRefRangeFemale}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label htmlFor=" Role" className="col-form-label">
                          Max Ref Range Female
                        </label>
                        <input
                          name="maxRefRangeFemale"
                          type="text"
                          placeholder="Max Ref Range Female"
                          className="form-control form-select-admin inputbgavanish"
                          value={values?.maxRefRangeFemale}
                          onChange={handleChange}
                        />
                        <div className="errorInputMessage">
                          {errors?.maxRefRangeFemale}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label htmlFor=" Role" className="col-form-label">
                          Ideal Value Female
                        </label>
                        <input
                          name="idealValueFemale"
                          type="text"
                          placeholder="Ideal Value Female"
                          className="form-control form-select-admin inputbgavanish"
                          value={values?.idealValueFemale}
                          onChange={handleChange}
                        />
                        <div className="errorInputMessage">
                          {errors?.idealValueFemale}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label htmlFor=" Role" className="col-form-label">
                          Units Female
                        </label>
                        <input
                          name="unitsFemale"
                          type="text"
                          placeholder="Units Female"
                          className="form-control form-select-admin inputbgavanish"
                          value={values?.unitsFemale}
                          onChange={handleChange}
                        />
                      </div>
                    </>
                  )}
                  <div className="d-flex justify-content-center">
                    {showMoreFields ? (
                      <button
                        className="morefield_btn"
                        type="button"
                        onClick={() => setShowMoreFields(false)}
                      >
                        Less Fields <i className="fa-solid fa-arrow-up"></i>
                      </button>
                    ) : (
                      <button
                        className="morefield_btn"
                        type="button"
                        onClick={() => setShowMoreFields(true)}
                      >
                        More Fields <i className="fa-solid fa-arrow-down"></i>
                      </button>
                    )}
                  </div> */}
                </div>
                <div className="row" style={{ padding: "12px" }}>
                  <div className="search-test-div">
                    <div className="globaltest">
                      {globalTestDetailsList?.map((ele, index) => {
                        return (
                          <div key={index}>
                            <button
                              type="button"
                              className={`${
                                ele?.isMapped
                                  ? "globaltest-true"
                                  : "globaltest-false"
                              }`}
                            >
                              {ele?.globalTestName}
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                {(userDetail?.requestStatus === "Rejected" ||
                  userDetail?.requestStatus === "Accepted") &&
                  data?.remarks && (
                    <div className="remarks mt-4">
                      <h5 className="font-bold text-black bottom-spacing-20 mb-3">
                        Remarks
                      </h5>
                      <textarea
                        className="textarea textareaConfirmation font-medium"
                        style={{ height: "130px" }}
                        placeholder="Type Something Here..."
                        value={data?.remarks}
                        disabled={true}
                      ></textarea>
                    </div>
                  )}
              </div>
              <div className="modal-footer modal-footer-admin justify-content-between accept-reject-btns bottom-0  mt-4">
                <div>
                  {data?.requestStatus === "Approved" && (
                    <div className="text-footer">
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          dispatch(
                            activeInactiveTestPackageNetworkAction({
                              isActive: e.target.checked,
                              facilityId: values?.facilityId,
                              providerId: values?.providerId,
                            })
                          );
                          setFieldValue("isActive", e.target.checked);
                        }}
                        checked={values?.isActive}
                      />
                      Active
                    </div>
                  )}
                </div>
                <button type="submit" className="savedetails">
                  <img
                    style={{ marginRight: "6px" }}
                    src="./../images/save-icon-white.png"
                    alt=""
                  />
                  Save
                </button>
              </div>
            </form>
          );
        }}
      </Formik>
    </>
  );
};
